import { render, staticRenderFns } from "./TableTabComponent.vue?vue&type=template&id=3912c915&"
import script from "./TableTabComponent.vue?vue&type=script&lang=js&"
export * from "./TableTabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports